import React, { memo } from 'react';
import cx from 'clsx';

import { IconRcObtuseArrow } from 'assets';

import style from './index.module.css';

type SortIconProps = {
  className?: string;
  order?: 'desc' | 'asc' | false;
};

export const SortIcon = memo(({ className, order }: SortIconProps) => {
  return (
    <div className={cx(style.sortIcon, className)}>
      <IconRcObtuseArrow className={cx(style.arrowIcon, order === 'asc' && style.activeOrder)} />
      <IconRcObtuseArrow
        className={cx(style.arrowIcon, style.arrowDown, order === 'desc' && style.activeOrder)}
      />
    </div>
  );
});

export default SortIcon;
